import { nanoid } from "nanoid";
import { TSortWordsExerciseColumn } from "types/app/exercises";

export const getColumnInitialValues = (): TSortWordsExerciseColumn<string> => ({
  id: nanoid(),
  name: "",
  value: "",
});
